module.exports = __webpack_public_path__ + "static/media/profile.db88db6b.jpg";